import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { IClinicalCategory, IClinicalCategoryListRequest } from "./iclinical-category";

@Injectable({ providedIn: 'root' })
export class ClinicalCategoryService {
    private _category: BehaviorSubject<IClinicalCategory | null> = new BehaviorSubject<IClinicalCategory | null>(null);
    private _categories: BehaviorSubject<IClinicalCategory[]> = new BehaviorSubject<IClinicalCategory[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get category$(): Observable<IClinicalCategory | null> {
        return this._category.asObservable();
    }

    get categories$(): Observable<IClinicalCategory[]> {
        return this._categories.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }



    getCategory(categoryData: IClinicalCategoryListRequest): Observable<BaseRespone<{ pagination: PaginationResult; clinicalCategories: IClinicalCategory[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; clinicalCategories: IClinicalCategory[] }>>(`${environment.baseURl}/ClinicalCategory/list`, categoryData).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._categories.next(response.result.clinicalCategories);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createCategory(category: IClinicalCategory): Observable<BaseRespone<IClinicalCategory>> {
        return this._httpClient.post<BaseRespone<IClinicalCategory>>(`${environment.baseURl}/ClinicalCategory`, category)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newcategory) => {
                    return newcategory;
                })
            )
    }

    updateCategory(category: IClinicalCategory): Observable<BaseRespone<IClinicalCategory>> {
        return this.categories$.pipe(
            take(1),
            switchMap(categories => this._httpClient.put<BaseRespone<IClinicalCategory>>(`${environment.baseURl}/ClinicalCategory`, category).pipe(
                map((updated: BaseRespone<IClinicalCategory>) => {

                    // Find the index of the updated product
                    const index = categories.findIndex(item => item.id === category.id);

                    // Update the product
                    categories[index] = category;

                    // Update the products
                    this._categories.next(categories);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    deletecategory(id: number): Observable<BaseRespone<boolean>> {
        return this.categories$.pipe(
            take(1),
            switchMap(category =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/ClinicalCategory/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const categorypatient = category.filter(item => item.id !== id);
                            this._categories.next(categorypatient);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }
}
